import { Currency } from '@/Domain/Batch/Currency'
import { StringifiedAmount } from './StringifiedAmount'
import { SpeciesOffer } from './SpeciesOffer'

export class Offer {
  private _globalAmount: Currency
  private _stringifiedAmount: StringifiedAmount
  private _speciesOffers: SpeciesOffer[]

  constructor (
    globalAmount: Currency,
    stringifiedAmount: StringifiedAmount,
    speciesOffers?: SpeciesOffer[]
  ) {
    this._globalAmount = globalAmount
    this._stringifiedAmount = stringifiedAmount
    this._speciesOffers = speciesOffers || []
  }

  globalAmount (): string {
    return this._globalAmount.toString()
  }

  stringifiedAmount (): string {
    return this._stringifiedAmount.value()
  }

  speciesAmount (internalId: number, target: string): string {
    const offer = this.searchSpeciesOffer(internalId, target)
    return offer === null ? '0' : offer.globalAmount()
  }

  checkOffer (internalId: number, target: string): boolean {
    const offer = this.searchSpeciesOffer(internalId, target)
    return offer !== null
  }

  private searchSpeciesOffer (speciesInternalId: number, target: string): SpeciesOffer | null {
    const foundOffer = this._speciesOffers.find(current => {
      return current.internalId() === speciesInternalId && current.offerTarget() === target
    })
    if (foundOffer === undefined) { return null }
    return foundOffer
  }
}
